import * as React from "react";

export const ArrowForward = () => (
  <svg
    className="elm-block elm-pointer-events-none"
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3993 0.805837C10.7654 0.439721 11.359 0.439721 11.7251 0.805837L19.1493 8.23001C19.4491 8.52977 19.5034 8.98201 19.3123 9.33705C19.2695 9.41844 19.2138 9.49485 19.1453 9.5633L11.7212 16.9875C11.3551 17.3536 10.7615 17.3536 10.3953 16.9875C10.0292 16.6214 10.0292 16.0278 10.3953 15.6617L16.2229 9.83414L1.52612 9.83414C1.00148 9.83414 0.576172 9.4144 0.576172 8.89664C0.576172 8.37887 1.00148 7.95914 1.52612 7.95914L16.2268 7.95914L10.3993 2.13166C10.0332 1.76555 10.0332 1.17195 10.3993 0.805837Z"
      fill="#404040"
    />
  </svg>
);
